import { Stack } from '@mui/material';
import React from 'react';

import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

export enum PageStatSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum PageStatColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type PageStatsPropsType = {
  statValue: number;
  statTitle: string;
  size?: PageStatSize;
  color?: PageStatColor;
  reversed?: boolean;
};

const PageStats: React.FC<PageStatsPropsType> = ({
  statValue,
  statTitle,
  size = PageStatSize.MEDIUM,
  color = PageStatColor.PRIMARY,
  reversed = false,
}) => {
  const ValueVariantMap = new Map<PageStatSize, WsTypoVariants>();
  ValueVariantMap.set(PageStatSize.SMALL, WsTypoVariants.BODY1);
  ValueVariantMap.set(PageStatSize.MEDIUM, WsTypoVariants.SUB_TITLE);
  ValueVariantMap.set(PageStatSize.LARGE, WsTypoVariants.TITLE);

  const TitleVariantMap = new Map<PageStatSize, WsTypoVariants>();
  TitleVariantMap.set(PageStatSize.SMALL, WsTypoVariants.BODY2);
  TitleVariantMap.set(PageStatSize.MEDIUM, WsTypoVariants.BODY1);
  TitleVariantMap.set(PageStatSize.LARGE, WsTypoVariants.SUB_TITLE);

  const ColorMap = new Map<PageStatColor, WsTypoColors>();
  ColorMap.set(PageStatColor.PRIMARY, WsTypoColors.PRIMARY);
  ColorMap.set(PageStatColor.SECONDARY, WsTypoColors.SECONDARY);

  return (
    <Stack direction={reversed ? 'column-reverse' : 'column'}>
      <WsTypography
        variant={ValueVariantMap.get(size)}
        color={color === PageStatColor.SECONDARY ? WsTypoColors.SECONDARY : WsTypoColors.PRIMARY}
      >
        {`${statValue}`}
      </WsTypography>
      <WsTypography
        variant={TitleVariantMap.get(size)}
        color={ColorMap.get(color)}
        opacity={color === PageStatColor.SECONDARY ? false : true}
      >
        {statTitle}
      </WsTypography>
    </Stack>
  );
};

export default PageStats;
